import { useEffect, useState } from 'react';

import { SLASH_COMMANDS_URL_PARAM } from './constants';
import { decodeSharePayload } from './slashCommandUtils';
import { SlashCommandSharePayload } from './types';

export const useSlashCommandImport = () => {
  const [importPayload, setImportPayload] =
    useState<SlashCommandSharePayload | null>(null);
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get(SLASH_COMMANDS_URL_PARAM);
    if (encoded) {
      const payload = decodeSharePayload(encoded);
      if (payload && payload.commands.length > 0) {
        setImportPayload(payload);
        setIsImportDialogOpen(true);
      }
      // Clean the URL parameter
      params.delete(SLASH_COMMANDS_URL_PARAM);
      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  const dismissImport = () => {
    setIsImportDialogOpen(false);
    setImportPayload(null);
  };

  return {
    importPayload,
    isImportDialogOpen,
    setIsImportDialogOpen,
    dismissImport,
  };
};
